/*
 * @Author: Ashley.Liu
 * @Date: 2022-10-31 16:03:56
 * @LastEditTime: 2022-11-01 18:22:36
 * @Description: desc
 */

export default {
  lineNumbers: true, // show number count
  mode: 'application/json', // language
  gutters: ['CodeMirror-lint-markers'],
  theme: 'abcdef', // theme idea/abcdef, need import corresponding css
  readOnly: false,
  keyMap: 'sublime', // shot cuts, need import corresponding js
  autofocus: false,
  autoRefresh: true,
  lint: true,
  lineWrapping: true,
  matchBrackets: true,
  autoCloseBrackets: true,
}
